import React from 'react';
import { createContext, useContext, ReactNode } from 'react';
import type { GlobalsTools } from '../types';

interface GlobalsProviderProps {
  tools: GlobalsTools;
  children: ReactNode;
}

const GlobalsContext = createContext<GlobalsTools | undefined>(undefined);

export function GlobalsProvider({ tools, children }: GlobalsProviderProps) {
  return (
    <GlobalsContext.Provider value={tools}>{children}</GlobalsContext.Provider>
  );
}

export const useGlobals = (): GlobalsTools => {
  const context = useContext(GlobalsContext);
  if (!context) {
    throw new Error('useGlobals must be used within GlobalsProvider');
  }
  return context;
};
